export const authPaths = {
  AUTH: "",
};
